import React, { useState } from "react";
import { Tabs } from "antd";
import { Button, Box } from "@chakra-ui/react";
import { RepaymentsTable } from "../tables";
import "./styles/borrowerTab.css";
import { useSelector } from "react-redux";
import { CSVLink } from "react-csv";
import { DateRangeWrapper } from "components/common";
import { DownOutlined, DownloadOutlined } from "@ant-design/icons";
import _, { isEmpty } from "lodash";
import { RootState } from "types";
import { getRepaymentsData } from "redux/actions/repaymentActions";

const { TabPane } = Tabs;

export default function RepaymentsTab() {
  const repaymentState = useSelector(
    (state: RootState) => state.repaymentReducer
  );
  const settingsState = useSelector(
    (state: RootState) => state.settingsReducer
  );
  const userData = useSelector(
    (state: RootState) => state.authReducer.loginDataTwo
  );
  const info = settingsState?.settingData?.data?.info;
  const download_list = repaymentState?.repaymentsDownloadList.map(
    repayment => {
      const newRepayment = _.cloneDeep(repayment);

      newRepayment.repaymentDate = newRepayment.loan?.repaymentDate;
      delete newRepayment.loan;

      return newRepayment;
    }
  );
  const isLoading = repaymentState?.requestLoading;
  const isListEmpty = isEmpty(download_list);
  const [showDateRange, setShowDateRange] = useState(false);
  const toggleDateRange = () => {
    showDateRange ? setShowDateRange(false) : setShowDateRange(true);
  };

  return (
    <Tabs defaultActiveKey="1">
      <TabPane tab="Repayments" key="1">
        <Box className="borrowers-table-box">
          <Box py="3" d="flex" flexDir="row-reverse">
            <Button
              variant="action"
              rightIcon={<DownloadOutlined />}
              isDisabled={isListEmpty || isLoading}
              className="download-borrowers-btn"
            >
              {isListEmpty ? (
                "Download"
              ) : (
                <CSVLink
                  data={download_list}
                  filename={`${
                    info?.businessName || userData?.businessName || ""
                  }_VeendHQAutoLending.repayments.csv`}
                  target="_blank"
                  className="no-hover"
                >
                  Download
                </CSVLink>
              )}
            </Button>
          </Box>
          <Box className="transactions-table-header">
            <Box className="table-btns">
              <DownOutlined
                className={
                  showDateRange
                    ? "date-range-toggle-arrow arrow-up"
                    : "date-range-toggle-arrow"
                }
              />
              {/* eslint-disable-next-line */}
              <a onClick={toggleDateRange} className="date-range-toggle">
                set date range
              </a>
            </Box>
          </Box>
          {showDateRange ? (
            <DateRangeWrapper filterAction={getRepaymentsData} />
          ) : null}
          <RepaymentsTable />
        </Box>
      </TabPane>
    </Tabs>
  );
}
